module.exports = __webpack_public_path__ + "static/media/nicol.2236c7e7.jpg";